const config = {};
const setConfig = (_config) => {
  Object.keys(_config).forEach(i => {
    config[i] = _config[i];
  });
  return config;
};

const getConfig = () => config;

export { setConfig, getConfig };